import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'tf-core-fb-editor-divider',
  templateUrl: './fb-editor-divider.component.html',
  styleUrls: ['./fb-editor-divider.component.css']
})
export class FbCoreEditorDividerComponent implements OnInit {
    @Input()
    showText: boolean;

    @Input()
    showTooltip: boolean;

    @Input()
    tooltipText: string;

    @Output()
    clickEvent = new EventEmitter();

    constructor() { }

    ngOnInit(): void {
    }
}
